const MaterialStructure = Object.freeze({
	diffuseUnlit: [
		'name',
		'type',
		'color',
		'map',
		'alphaMode',
		'alpha',
		'alphaCutoff',
	],
	standard: [
		'name',
		'type',
		'color',
		'map',
		'alphaMode',
		'alpha',
		'alphaCutoff',
		'emissive',
		'emissiveMap',
		'metalness',
		'roughness',
		'metallicRoughnessMap',
		'normalMap',
		'aoMap',
	],
	depthMask:
		[
			'name',
			'type',
		],
	video:
		[
			'name',
			'type',
			'color',
			'video',
		],
	line:
	[
		'name',
		'type',
		'lineColor',
		'lineThickness',
	],
});

export default MaterialStructure;
